"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  // Spacers
  none: "0",
  extraSmall: "0.25rem",
  small: "0.5rem",
  medium: "1rem",
  large: "1.5rem",
  extraLarge: "2rem"
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/theme/dist/cjs/layout/spacers.js
// module id = 1612
// module chunks = 0